<template>
  <div class="application-list">
    <v-card>

        <v-app-bar flat >
          <v-icon>mdi-apps</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('app.apps')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu left bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>

              </v-list>
            </v-menu>
        </v-app-bar>
      <v-card-text>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
:items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
          :loading="isLoading"
          :loading-text="$t('global.loading')"
          :options.sync="options"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="@id"
          @update:options="onUpdateOptions"
          @click:row="openURI"

          hide-default-header
          hide-default-footer
        >
            <template slot="item.image" slot-scope="{ item }">
              <v-img
                class="cursorpointer"
                lazy-src="@/assets/imagenotfound.png"
                aspect-ratio="4/3"
                height="25"
                width="150"
                left
                contain
                :key="getItemImageKey(item)"
                :src="getImageUrlByObject(item)"
              ></v-img>
            </template>
            <template slot="item.name" slot-scope="{ item }">
              <strong >
                <span class="cursorpointer">{{ item.name }}</span>
              </strong>
            </template>

        </v-data-table>


      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'AppList',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {
  },
  data() {
    return {
      headers: [
      { text: this.$t('global.image'), value: 'image' ,align: 'left'},
      { text: this.$t('global.name'), value: 'name' ,align: 'left'},
    ],
    filters: {
      'view' : false,
    },
    selected: [],
    footer: {
      'itemsPerPageText': "",
    },
    options: {sortBy : ['name'], sortDesc : [false]},
    filter : "wx25"
    /*
    items:  [
        { 'logo' : 'https://lynxworkflow.techno.lynxter.fr/img/logo_dark.22f6a4a1.png', 'name' : 'LynxWorkFlow' , 'uri' : 'https://lynxworkflow.techno.lynxter.fr'},
        { 'logo' : 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Microsoft_Planner_(2019%E2%80%93present).svg/1200px-Microsoft_Planner_(2019%E2%80%93present).svg.png', 'name' : 'Planner', 'uri' : 'https://tasks.office.com/lynxter.fr/fr-FR/Home/Planner/'},
        { 'logo' : 'https://net-security.fr/wp-content/uploads/Bitwarden_onprem/bitwarden-logo.png', 'name' : 'Bitwarden', 'uri' : 'https://bitwarden.techno.lynxter.fr'},
        { 'logo' : 'https://drawio-app.com/wp-content/uploads/2020/11/drawio_logo_RGB_dark_small_398x100px.png', 'name' : 'DrawIo', 'uri' : 'https://app.diagrams.net/'},

      ],
      */
    }
  },
  computed: {
    ...mapGetters('application', {
      items: 'list'
    }),
    ...mapFields('application', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
  },
  methods: {
    ...mapActions('application', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    openURI(data) {
      window.open(data.url, "_blank");
    }
  }
};
</script>
